import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors } from "@styles/color.styles";

export const root: CSSProperties = {
  width: 58,
  height: 58,
  border: `6px solid ${colors.blueDusk.standard}`,
  boxSizing: "content-box",
  borderRadius: "50%",
  position: "absolute",
  top: "calc(50% - 35px)",
  left: "calc(50% - 35px)",
};

export const center: CSSProperties = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 100,

  "&:before": {
    content: '""',
    display: "block",
    height: 8,
    width: 8,
    background: colors.blueDusk.standard,
    borderRadius: "50%",
  },
};

export const minute: CSSProperties = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  animation: "$rotate 4s infinite linear",

  "&:before": {
    position: "absolute",
    left: "calc(50% - 4px)",
    top: 8,
    content: '""',
    borderBottom: `24px solid ${colors.blueDusk.standard}`,
    borderLeft: "2px solid transparent",
    borderRight: "2px solid transparent",
    borderRadius: "0 0 8px 8px",
    height: 0,
    width: 4,
  },
};

export const hour: CSSProperties = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  animation: "$rotate 48s infinite linear",

  "&:before": {
    position: "absolute",
    left: "calc(50% - 4px)",
    top: 16,
    content: '""',
    borderBottom: `15px solid ${colors.blueDusk.standard}`,
    borderLeft: "2px solid transparent",
    borderRight: "2px solid transparent",
    borderRadius: "0 0 8px 8px",
    height: 0,
    width: 4,
  },
};

export const styles = {
  root,
  center,
  minute,
  hour,
  "@keyframes rotate": {
    "100%": {
      transform: "rotateZ(360deg)",
    },
  },
};
